import React from 'react';
import './index.css';
import { useField } from 'formik';

const CustomRadio = ({ options, name, label, selectedValue, onChange, props }) => {
    const [field, meta] = useField({ name, ...props });

    return (
        <div className="form-group">
            {label && <label >{label}</label>}
            <div className="custom-radio-options">
                {options?.map((option) => (
                    <label key={option} className="custom-radio">
                        <input
                            type="radio"
                            name={name}
                            value={option}
                            checked={selectedValue === option}
                            onChange={onChange}
                        />
                        <span className="custom-radio-circle"></span>
                        {option}
                    </label>
                ))}
            </div>
            {meta.touched && meta.error && (
                <span className="error-message">{meta.error}</span>
            )}
        </div>
    );
};

export default CustomRadio;
